<template>
  <div class="c-main">
    <div
      class="banner"
      :style="{
        backgroundImage: `url('${BASE_URL}${
          $route.query.type == 'customer' ? customerHeader.url : newHeader.url
        }')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
      }"
    >
      <div class="banner-container">
        <h1 class="banner-title">
          {{ $route.query.type == "customer" ? "客户案例" : "新闻动态" }}
        </h1>
        <div
          class="banner-desc"
          v-html="
            $route.query.type == 'customer'
              ? customerHeader.content
              : newHeader.content
          "
        ></div>
      </div>
      <div class="breadcrumb">
        <span @click="$router.push('/')">首页</span>
      </div>
    </div>

    <div class="news-dynamic-page">
      <!-- 标题区域 -->
      <h1 class="page-title">{{ newsList.infoTitle }}</h1>
      <div class="date">{{ newsList.createDate.split(" ")[0] || "" }}</div>

      <!-- 新闻内容区域 -->
      <div class="news-content-area">
        <!-- <div class="news-text" v-for="i in 4" :key="i"> -->
        <p ref="contentRef" style="margin-bottom: 18px" v-html="newsList.infoContent"></p>
        <img
          style="height: 355px"
          :src="BASE_URL + newsList.infoImage"
          alt=""
        />
        <!-- </div> -->
      </div>

      <!-- 分页导航 -->
      <div class="page-nav">
        <div class="topbottom">
          <div @click="clickPreInfoTitle" class="up">
            上一篇：{{ newsList.preInfoTitle }}
          </div>
          <div @click="clickNextInfoTitle" class="down">
            下一篇：{{ newsList.nextInfoTitle }}
          </div>
        </div>
        <div class="return-btn" @click="goNew">返回列表 →</div>
        <div style="height: 40px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { infoDetail, getConf } from "../../api/article";
// import ArticleItem from "../Components/ArticleItem";

export default {
  name: "productCenter",
  data() {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      newsList: {
        createDate: "",
        infoContent: "",
      },
      newHeader: {},
      customerHeader: {},
      contentRef: null,
    };
  },
  // filters: {
  //   setText(val) {
  //     return val
  //       .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
  //       .replace(/<br\/?>/gi, "\n")
  //       .replace(/<[^>/]+>/g, "")
  //       .replace(/(\n)?<\/([^>]+)>/g, "")
  //       .replace(/\u00a0/g, " ")
  //       .replace(/&nbsp;/g, " ")
  //       .replace(/<img[^>]+src\\s*=\\s*['\"]([^'\"]+)['\"][^>]*>/g, "")
  //       .replace(/<\/?(img|table)[^>]*>/g, "") // 去除图片和表格
  //       .replace(/<\/?(a)[^>]*>/g, ""); //  去除a标签
  //   },
  // },
  computed: {},
  created() {},
  mounted() {
    this.fetchHomeConf();
  },
  methods: {
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.newHeader = JSON.parse(response.data.newHeader) || {};
        this.customerHeader = JSON.parse(response.data.customerHeader) || {};
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
    clickPreInfoTitle() {
      this.$router.push({
        path: `/newdetails/${this.newsList.preInfoId}`,
        query: { type: this.$route.query.type },
      });
    },
    clickNextInfoTitle() {
      this.$router.push({
        path: `/newdetails/${this.newsList.preInfoId}`,
        query: { type: this.$route.query.type },
      });
    },
    goNew() {
      this.$router.go(-1);
    },

    async fetchNewsDetailData() {
      console.log("route:", this.$route);
      try {
        this.isLoading = true;
        const res = await infoDetail(this.$route.params.preInfoId);
        this.newsList = res.data;
        // 数据加载后调整视频大小
        this.$nextTick(() => {
          this.adjustVideoSize();
        });
      } catch (error) {
        console.error("新闻数据请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
        this.newsList = [];
        this.totalCount = 0;
      } finally {
        this.isLoading = false;
      }
    },
    adjustVideoSize() {
      const contentEl = this.$refs.contentRef;
      if (!contentEl) return;
      
      const videos = contentEl.querySelectorAll('video, iframe, embed');
      videos.forEach((el) => {
        el.removeAttribute('width');
        el.removeAttribute('height');
        el.style.maxWidth = '100%';
        el.style.width = '100%';
        el.style.height = 'auto';
        el.style.display = 'block';
      });
    },
  },
  watch: {
    "$route.path": {
      handler() {
        this.fetchNewsDetailData();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
/* 非scoped样式，用于处理v-html渲染的视频 */
.news-content-area video,
.news-content-area iframe,
.news-content-area embed {
  max-width: 100% !important;
  width: 100% !important;
  height: auto !important;
  display: block !important;
  box-sizing: border-box !important;
}

.news-content-area video[style],
.news-content-area iframe[style] {
  max-width: 100% !important;
  width: 100% !important;
  height: auto !important;
}

.news-content-area video[width],
.news-content-area iframe[width] {
  max-width: 100% !important;
  width: 100% !important;
  height: auto !important;
}
</style>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.c-main {
  min-height: calc(100vh - 100px);
}
.banner {
  width: 100%;
  height: 450px;
  // @include backgroundImage("../../assets/banner.png");
  position: relative;
  .banner-container {
    position: absolute;
    left: 300px; // 距离左侧边距
    top: 177px;
    transform: translateY(-50%);
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    .banner-title {
      font-size: 48px;
      font-weight: bold;
      margin: 0 0 20px;
      line-height: 1.2;
    }

    .banner-desc {
      font-size: 16px;
      margin: 0 0 16px;
      opacity: 0.9;
      max-width: 600px;
    }
  }
  .breadcrumb {
    position: absolute;
    left: 300px; // 距离左侧边距
    bottom: 24px;
    font-size: 12px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    span {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
    }

    .separator {
      cursor: default;
      opacity: 0.6;
    }
  }
}
.news-dynamic-page {
  max-width: 940px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.page-title {
  font-weight: bold;
  font-size: 28px;
  color: #000a25;
  margin-bottom: 20px;
  width: 900px;
    white-space: normal;    
  word-wrap: break-word;  
  word-break: break-all; 
  
  }

.date {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.news-content-area {
  margin-bottom: 30px;
  width: 900px;
  overflow: hidden;
}

.news-text {
  margin-bottom: 20px;
  line-height: 1.8;
}

.page-nav {
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.page-nav .topbottom {
  font-weight: 400;
  font-size: 16px;
  color: #000a25;
  line-height: 28px;
}
.page-nav .topbottom .up,
.page-nav .topbottom .down,
.page-nav .return-btn {
  cursor: pointer;
}
.page-nav .topbottom .up:hover {
  color: #005cef;
}
.page-nav .topbottom .down:hover {
  color: #005cef;
}
.page-nav .return-btn {
  font-size: 16px;
  float: right;
  color: #0066cc;
}

.page-nav a:hover {
  text-decoration: underline;
}
</style>
